/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VlcrVlrOrgSecretSpec { 
    app_id: string;
    app_secret: string;
    authorization_timestamp: Date;
}

